import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=bc9dd6fc&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=ts&"
export * from "./AppFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=bc9dd6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9dd6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bc9dd6fc', component.options)
    } else {
      api.reload('bc9dd6fc', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=bc9dd6fc&scoped=true&", function () {
      api.rerender('bc9dd6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/AppFooter.vue"
export default component.exports